import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
    Col
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux"
import { appendData } from "store/Mode/actions"
import FabricCanvas from "../FabricCanvas"
import UnitModal from "../UnitModal"
import { salesDeveloperPrefix } from "configs/routePrefix";
import CancelModal from "components/CancelModal"
import InterActiveModeService from "services/SalesDeveloper/InterActiveModeService"
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";

const AddMode = (props) => {
    const [modal, setModal] = useState(false)
    const [selectedUnit, setSelectedUnit] = useState([])
    const modeData = useSelector(state => state.Mode)
    const filterData = useSelector(state => state.adminFilter)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [buildingErrors, setBuildingErrors] = useState({});

    const [headerList, setHeaderList] = useState([])
    const [headerListData, setHeaderListData] = useState([])

    const addSelectedUnit = (unit_id) =>{
        let check = selectedUnit?.filter(id => id === unit_id)
        if(!check.length){
            // setSelectedUnit([...selectedUnit, {
            //     building_id: headerList[0]?.constrains?.id,
            //     units_id: 
            // }])
        }
        // if(selectedUnit.length === 0){
        //     setSelectedUnit([{
        //         building_id: headerList[0]?.constrains?.id,
        //         units_id: [unit_id]
        //     }])
        // } else {
        //     selectedUnit?.map(item => {
        //         if(headerList[0]?.constrains?.id === item.id){
        //             setSelectedUnit([...selectedUnit, {
        //                 ...item,
        //                 units_id: [...item.id, unit_id]
        //             }])
        //         } else {
        //             setSelectedUnit([...selectedUnit, {
        //                 building_id: headerList[0]?.constrains?.id,
        //                 units_id: [unit_id]
        //             }])
        //         }
        //     })
        // }
        
        
    }
    useEffect(() => {
        const updatedList = []

        headerList.forEach((listItem => {
            modeData.images.forEach(img => {
                if (listItem.id === img.id) {
                    if(!img.title){
                        updatedList.push({...img, title: img.constrains.title})
                    } else {
                        updatedList.push(img)
                    }
                }
            })
        }))

        setHeaderListData([...updatedList])
    }, [headerList]);
    const getImagesList = (index) => {
        const customList = []
        if (modeData.images.length) {
            modeData.images.slice(1, index).reverse().forEach((img, index) => {
                if (index === 0) {
                    customList.push(img)
                } else if (img.id === customList.slice(-1)[0].comesForm.id) {
                    customList.push(img)
                }
            })
            return customList
        } else {
            return []
        }

    }

    const moveHander = (imgData) => {
        if(imgData.id === modeData.masterImg.id){
            dispatch(appendData({
                ...modeData,
                currentImge: {
                    id: imgData ?.id,
                    path: imgData ?.path,
                },
                previousImg: null
            }
            ))
        } else if(headerList.findIndex(img => img.id === imgData.id) === 0){
            dispatch(appendData({
                ...modeData,
                currentImge: {
                    id: imgData ?.id,
                    path: imgData ?.path,
                },
                previousImg: {
                    id: modeData.masterImg ?.id,
                    path: modeData.masterImg ?.path,
                }
            }
            ))
        } else{
            dispatch(appendData({
            ...modeData,
            currentImge: {
                id: imgData ?.id,
                path: imgData ?.path,
            },
        }
        ))
        }
        resetScroll()
    }

    const resetScroll = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    const onSubmitHandler = () => {
        const list = modeData.images.slice(1)
        let isValid = true
        if(Object.values(buildingErrors).includes(true)){
            // toast.error("Edit Building First")
            return
        }
        // if (modeData.images.length === 1) {
        //     const img = modeData.images[0]
        //     if (img.shapes.length === 0) {
        //         toast.error("Complete All Phases")
        //         return
        //     }
        // }
        if (isValid) {
            modeData.images.forEach(img => {
                img?.shapes?.forEach(shape => {
                    if (!shape ?.idImage || !shape ?.hotspot ) { // || !validate(shape ?.title)
                        isValid = false
                        toast.error(`Add Photo to ${shape.title}`)
                        return
                    }
                })
            })
        }
        const units = []
        const uncompletedUnits = []
        if (isValid) {
            modeData.images.forEach(img => {
                img?.shapes?.forEach(shape => {
                    if (shape ?.hotspot.type === "unit" ) {
                        units.push(shape)
                    }
                })
            })
 
            units.forEach(unit => {
                let isExist = modeData.images.find(img => img.id === unit.idImage.id)
                if (!isExist) {
                    uncompletedUnits.push(unit)
                }
            })
 
            if (uncompletedUnits.length === 1) {
                const unit = uncompletedUnits[0]
                isValid = false
                toast.error(`Please Insert Images To ${unit.title} Unit `)
                return
            } else if(uncompletedUnits.length > 1 ) { 
                const units = uncompletedUnits.map(unit => `${unit.title }`)
                isValid = false
                toast.error(`Please Insert Images To [ ${units} ] Units `)
                return
            }
        }

        let shapesNumber = 0
        if (isValid) {
            modeData.images.forEach((img) => {
                shapesNumber += img ?.shapes ?.length
            })
            if (shapesNumber + 1 !== modeData.images.length) {
                isValid = false
                toast.error(`Complete All Phases`)
                return
            }
        }
        if (isValid) {
            let errorList = []
            for (let index = 0; index < modeData.images.length; index++) {
                let img = modeData.images[index]
                if ((img ?.constrains ?.type === "unit" && img ?.images ?.length === 0) || (img ?.constrains ?.type === "unit" && !img ?.images)) {
                    errorList.push(img)
                }
            }
 
            if (errorList?.length > 0) {
                const units = errorList.map(unit => `${unit.title }`)
                isValid = false
                // errorList?.map(img => toast.error(`Please Insert Images To ${img?.title} Unit`))
                toast.error(`Please Insert Images To [ ${units} ] ${units?.length > 0 ? 'Units' : 'Unit'}`)
                return
            } 
            // else if (errorList.length === 1) {
            //      let img = errorList[0]
            //     isValid = false
            //     toast.error(`Please Insert Images To ${img.constrains?.label.split('/')[0]} Unit `)
            //     return
            // }

        }
        if (isValid) {
            list.forEach(img => {
                if ((img ?.constrains ?.type !== "unit" && img ?.shapes ?.length === 0)) {
                    isValid = false
                    toast.error(`Complete All Phases in ${img?.title}`)
                    return
                }
            })
        }

        if (isValid) {
            const images = modeData.images.map(img => {
                return {
                    ...img,
                    comesForm: img ?.comesForm ?.id
                }
            })

            let hotspotNumber = 0
            modeData.images.forEach(img => {
                hotspotNumber = hotspotNumber + img.shapes.length
            })

            const updatedImages = images.map(({ image, images, constrains, ...rest }) => {
                if (constrains ?.type === "unit") {
                    return { images, constrains, ...rest }
                } else {
                    return {
                        images: [],
                        constrains,
                        ...rest
                    }
                }
            })
            
            const internalUnits = (id, list) =>{
                const units = []
                let shapesData 
                if(list.filter(res => res.constrains?.type == 'layer')?.length > 0){
                    let update = list.filter(res => res.constrains?.type == 'layer')
                    let shapes = []
                    update?.map(item=> item.shapes.map(res=> shapes.push(res)))
                    shapesData = {...update[0], shapes: [...shapes]}
                } else {
                    shapesData = list.find(item => item?.constrains?.id == id)
                }
                shapesData.shapes.forEach(shape =>{
                    units.push(shape.hotspot.id)
                })
                
                return units

            }
            
            const updatedImagesTwo = modeData.images.map(img => {
                return {
                    ...img,
                    comesForm: img?.comesForm ? img?.comesForm?.id : null,
                    shapes: img.shapes.map((item) => {
                        if (item.hotspot.type  === "building") {
                            const x = internalUnits(item?.hotspot?.id, images)
                            return { 
                                ...item,
                                hotspot: {
                                    ...item.hotspot,
                                    units: x
                                }
                             }
                        } else {
                            return {
                                ...item
                            }
                        }
                    })
                }
            })

            const master = updatedImagesTwo?.filter(res=> !res.constrains && !res.title)
            delete master[0].image
            delete master[0].comesForm
            const updatedMaster = {
                ...master[0],
                // images: []
            }
            const data = {
                compound_id: modeData.compound.value,
                constrains: "",
                hotspots: hotspotNumber,
                image_id: modeData.type == "add" ? modeData.images[0].id : modeData.masterImg.id,
                images: [
                    updatedMaster,
                    ...updatedImagesTwo?.filter(res=> !!res.constrains && !!res.title)
                ],
            }
            setLoading(true)
            if (modeData.type == "add") {
                new InterActiveModeService().create(data).then(res => {
                    if (res && res.status === SuccessCreated) {
                        props.history.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`)
                        
                        toast.success("InterActive Mode Added ")
                    } else {
                        setLoading(false)
                    }
                })
            } else {
                new InterActiveModeService().update(modeData.editId, data).then(res => {
                    if (res && res.status === SuccessOk) {
                        props.history.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`)
                        toast.success("InterActive Mode Updated ")
                    } else {
                        setLoading(false)
                    }
                })  
            }
        }
    }

    return (
        <>
            <div className='page-content ' style={{ paddingBottom: "2rem" }}>
                <MetaTags>
                    <title>Add Interactive Mode</title>
                </MetaTags>
                <div className="d-felx mb-3 ms-2">
                   {headerList.length > 0 && <button className="p-0 m-0 border-0"
                        style={{background: 'none'}}
                        onClick={() => {
                            const updatedList = headerList?.length > 1 ? headerList.splice(-1, 1) : []
                            if(updatedList?.length == 0){
                                moveHander(modeData.masterImg)
                                setHeaderList([])
                            } else{
                                headerListData.map((img, index) => {
                                    if(img.id !== modeData.currentImge.id){
                                        const index = headerList?.findIndex(imgdata => img.id === imgdata.id)
                                        const updatedList = headerList?.slice(0, index+1)
                                        setHeaderList([...updatedList])
                                        moveHander(img)
                                    }
                                })
                            }
                            if(headerList?.length == 0){
                                props.history.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`)
                            }
                        }}>
                        <i className="fa fa-arrow-left text-success font-size-16"></i>
                    </button>}
                    <h3 className={`fw-bold d-inline ${headerList.length > 0 ? 'ps-2' : 'ps-3'}`}>{modeData.compound?.label}</h3>
                </div>
                <Container fluid className='bg-white p-3 '>
                    {modeData.images.length ? modeData.images.map((img, index) => {
                        return (
                        <Row key={index} className='w-100 p-0 m-0' style={{ display: parseInt(img.id) === parseInt(modeData.currentImge.id) ? "block" : "none" }}>
                            <span className="d-inline-block w-auto mb-3 fw-bold font-size-16  btn-hover" onClick={() => {
                                    moveHander(modeData.masterImg)
                                    setHeaderList([])
                            }} >Master Plan</span>

                            {headerListData.length > 0 ? <span className="fw-bold font-size-18 p-0">&gt;</span> : null}

                            {headerListData.length ? headerListData.map((img, index) => {
                                return (
                                    <React.Fragment key={index} >
                                        <span className="fw-bold font-size-16 btn-hover" onClick={() => {
                                            if(img.id !== modeData.currentImge.id){
                                                const index = headerList?.findIndex(imgdata => img.id === imgdata.id)
                                                const updatedList = headerList?.slice(0, index+1)
                                                setHeaderList([...updatedList])
                                                moveHander(img)
                                            }
                                        }}>{img?.title} {/*img.constrains?.label.split('/')[0] !== 'None' ? img.constrains?.label.split('/')[0] :*/} </span>

                                        {headerList.length - 1 > index ?
                                            <span className="fw-bold font-size-18 p-0">&gt;</span> : null}
                                    </React.Fragment>
                                )
                            }) : null}
                            
                            {parseInt(img.id) === parseInt(modeData.currentImge.id) && img ?.constrains ?.type === "unit" ?  <UnitModal key={index} setHeaderList={setHeaderList} headerList={headerList} /> : parseInt(img.id) === parseInt(modeData.currentImge.id) ? <FabricCanvas setHeaderList={setHeaderList} headerList={headerList} buildingErrors={buildingErrors} setBuildingErrors={setBuildingErrors} addSelectedUnit={addSelectedUnit} /> : null}
                        </Row>)
                        // if () {
                        //     return (
                        //         <>
                                    
                        //             {/* <span className="mr-2"  >{img.title}</span> */}
                        //             <UnitModal key={index} setHeaderList={setHeaderList} headerList={headerList} />
                        //         </>
                        //     )
                        // } else {
                        //     return (
                        //         <Row >
                                    
                        //             {parseInt(img.id) === parseInt(modeData.currentImge.id) ? <FabricCanvas setHeaderList={setHeaderList} headerList={headerList} addSelectedUnit={addSelectedUnit} /> : null}
                        //         </Row>
                        //     )

                        // }

                    }) : null}

                    <CancelModal modal={modal}
                        setModal={setModal}
                        goBackHandler={() => {
                            props.history.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`)
                        }}
                    />
                    <Row className="d-flex justify-content-between my-4 ">
                        <Col>
                            <button
                                type="button"
                                className="btn btnUpload btnHeight px-4"
                                onClick={() => {
                                    setModal(true)
                                }}
                                size={"lg"}>
                                Cancel
                            </button>
                        </Col>
                        <Col>
                            <button
                                type='button'
                                className="btn btn-success btnHeight px-4 float-end"
                                size={"lg"}
                                onClick={onSubmitHandler}
                                disabled={loading ? true : false}
                            >
                                Submit
                        </button>
                        </Col>
                    </Row>
                </Container>

            </div>
        </>
    )
}

let validate = (str) => {
    let count = 0
    for (let i = 0; i < str.length; i++) {
        if ((str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) || (str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122)) {
            count += 1
        }
    }

    return count >= 2 ? true : false

}

export default AddMode